function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H36V36H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f26524",
  d: "M23.84 75.9l-2.64-5.076a2.709 2.709 0 0 0-2.451-1.448H5.221a2.692 2.692 0 0 0-2.451 1.448L.133 75.878A1.1 1.1 0 0 0 0 76.36v6.832a2.239 2.239 0 0 0 2.291 2.184h19.418A2.239 2.239 0 0 0 24 83.192v-6.806a1.3 1.3 0 0 0-.16-.486zm-7.219-.61a1.151 1.151 0 0 0-1.119.863 3.636 3.636 0 0 1-7.085 0 1.108 1.108 0 0 0-1.117-.86H2.983l1.838-3.5a.526.526 0 0 1 .4-.254h13.531a.423.423 0 0 1 .4.254l1.811 3.5z",
  transform: "translate(6 -59.375)"
});

function SvgIconTrayOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrayOrange);
export default __webpack_public_path__ + "static/media/iconTrayOrange.b29afe5d.svg";
export { ForwardRef as ReactComponent };